import { render, staticRenderFns } from "./document-request-list.vue?vue&type=template&id=2a606104"
import script from "./document-request-list.vue?vue&type=script&lang=js"
export * from "./document-request-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports